import { useNavigate, useParams } from "react-router-dom";
import useTranslator from "../../../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../../context/auth/AuthContext";
import { haveValue } from "../../../helper/common";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { Button } from "../../../components/design";

const WelcomeOnboardingModal = ({ handleCompleteStep }) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const { workspaceId } = useParams();

  const [sharedUrl, setSharedUrl] = useState("");

  const { user } = useContext(AuthContext);
  const { loadAgencyProfile, loadProfilesLandlord } =
    useContext(LandLordContext);

  useEffect(() => {
    const effectFunc = async () => {
      var response = [];
      // if (user?.isParentLL && haveValue(user?.agency_id)) {
      //   response = await loadAgencyProfile(
      //     user?.agency_id?._id,
      //     1,
      //     10,
      //     "demo tenant"
      //   );
      //   setSharedUrl(
      //     `/${workspaceId}/profile-property?agencylink=${response?.data?.[0]?._id}`
      //   );
      // } else
      if (user?._id) {
        response = await loadProfilesLandlord(user?._id, "full", {
          searchVal: "demo tenant",
          page: 1,
          limit: 10,
        });
        setSharedUrl(
          `/${workspaceId}/profile-property?sharedprofileid=${response?.data?.[0]?._id}`
        );
      }
    };

    effectFunc();
  }, [user]);

  return (
    <div>
      <div>
        <Modal
          show={true}
          // onHide={handleCloseModal}
          centered
          className="welcome-landlord-onboarding-modal"
        >
          <Modal.Header>
            <div className="onboarding-bg">
              <div>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="credit-point-img">
                    <img src="/images/credit-point1.svg" alt="" />
                  </div>
                  <h1 className="mb-0">20</h1>
                </div>
                <p>{_t("creditPointsAwarded")}</p>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <h1>
              {_t("welcome")} {_t("dontKowHowToContinue")}
            </h1>
            <ul>
              <li>
                <img src="/images/send.svg" alt="" />
                <Button
                  variant="secondary"
                  href=""
                  onClick={(e) =>
                    navigate(
                      `/${workspaceId}/profile-request?inviteTenant=true`
                    )
                  }
                >
                  {_t("inviteTenant")}
                </Button>
              </li>
              <li>
                <img src="/images/add-property-icon.svg" alt="" />
                <Button
                  variant="secondary"
                  href=""
                  onClick={(e) => navigate("/home")}
                >
                  {_t("addYourProperty")}
                </Button>
              </li>
              <li>
                <img src="/images/tenant-profile-icon.png" alt="" />
                <Button
                  variant="secondary"
                  href=""
                  onClick={(e) => navigate(sharedUrl)}
                >
                  {_t("reviewATenantProfile")}
                </Button>
              </li>
            </ul>
            <Button size="lg" onClick={handleCompleteStep}>
              {_t("goToHome")}
            </Button>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default WelcomeOnboardingModal;
